import { baseTheme, extendTheme } from "@chakra-ui/react";
export var RealmsbaseTheme = extendTheme({
    colors: {
        primary: baseTheme.colors.teal,
    },
});
